import script from "./customStyleGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./customStyleGroup.vue?vue&type=script&lang=ts&setup=true"

import "./customStyleGroup.vue?vue&type=style&index=0&id=4cd3ca38&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd3ca38"]])

export default __exports__